/**
 * Slick slider executif de direction
 */

export const sliderDeDirection = () => {
  (function ($) {
    if($('#comteDirectionSlider').length === 0) {
      return;
    }

    $('#comteDirectionSlider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 966,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
          }
        },
      ]
    })
  })(jQuery);
}


/**
 * Slick slider executif de gestion
 */

 export const sliderDegestion = () => {
  (function ($) {
    if($('#comteDegestionSlider').length === 0) {
      return;
    }

    $('#comteDegestionSlider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 966,
          settings: {
            slidesToShow: 3,
            dots: true,
            arrows: false,
          }
        },
        {
          breakpoint: 700,
          settings: {
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
          }
        },
      ]
    })
  })(jQuery);
}

/**
 * Slick slider revolutions page
 */
 export const revolutionSlider = () => {
  (function ($) {
    if($('.realisations-slider__card-slider').length === 0) {
      return;
    }

    $('.realisations-slider__card-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 966,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1.25,
          }
        }
      ]
    })
  })(jQuery);
}

/**
 * Slick slider trusted partner
 */
 export const trustedPartner = () => {
  (function ($) {
    if($('#partnerSlider').length === 0) {
      return;
    }

    $('#partnerSlider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 966,
          settings: {
            slidesToShow: 3,
            dots: true,
            arrows: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 2,
          }
        }
      ]
    })
  })(jQuery);
}

/**
 * Slick slider executif de direction
 */

export const sliderNews = () => {
  (function ($) {
    if($('#newsSlider').length === 0) {
      return;
    }

    $('#newsSlider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: true,
      responsive: [
        {
            breakpoint: 600,
            settings: {
              dots: true,
              arrows: false,
            }
          }
      ]
    })
  })(jQuery);
}
